(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slide"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('hero-slideshow')) {

    class HeroSlideshow extends HTMLElement {

      connectedCallback() {

        if (document.readyState === 'loading') {

          document.addEventListener(
            'DOMContentLoaded',
            () => this.init(),
            { once: true }
          );

        } else {

          this.init();

        }

      }


      disconnectedCallback() {
        this.teardown();
      }


      init() {

        if (this.ready || !this.isConnected) {
          return;
        }


        this.slides = Array.from(
          this.querySelectorAll('[data-slide]')
        );


        if (this.slides.length < 2) {
          return;
        }


        this.ready = true;

        this.ac = new AbortController();

        const signal = this.ac.signal;


        this.index = 0;
        this.locked = false;
        this.timer = null;

        this.holds = new Set();


        this.dots = Array.from(
          this.querySelectorAll('[data-dot]')
        );


        this.effect =
          this.dataset.effect === 'fade'
            ? 'fade'
            : 'slide';


        this.delay =
          (parseInt(this.dataset.speed, 10) || 5) * 1000;


        this.duration =
          parseInt(this.dataset.duration, 10) || 600;


        const reduced =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;


        this.autoplay =
          this.dataset.autoplay === 'true' &&
          !reduced;


        const viewport =
          this.querySelector('[data-viewport]') || this;


        /* =====================================================
           SLIDE CLICK
           ===================================================== */

        this.slides.forEach((slide) => {

          slide.addEventListener(
            'click',
            (e) => {

              const clickedControl =
                e.target.closest(
                  'a, button, input, select, textarea, [data-prev], [data-next], [data-dot]'
                );


              if (clickedControl) {
                return;
              }


              const url =
                slide.getAttribute(
                  'data-slide-link'
                );


              if (!url) {
                return;
              }


              window.location.href = url;

            },
            { signal }
          );

        });


        /* =====================================================
           ARROWS
           ===================================================== */

        const prev =
          this.querySelector('[data-prev]');

        const next =
          this.querySelector('[data-next]');


        if (prev) {

          prev.addEventListener(
            'click',
            (e) => {

              e.preventDefault();
              e.stopPropagation();

              this.step(-1);

            },
            { signal }
          );

        }


        if (next) {

          next.addEventListener(
            'click',
            (e) => {

              e.preventDefault();
              e.stopPropagation();

              this.step(1);

            },
            { signal }
          );

        }


        /* =====================================================
           DOTS
           ===================================================== */

        this.dots.forEach((dot, i) => {

          dot.addEventListener(
            'click',
            (e) => {

              e.preventDefault();
              e.stopPropagation();

              const direction =
                i > this.index ? 1 : -1;

              this.go(
                i,
                direction
              );

            },
            { signal }
          );

        });


        /* =====================================================
           KEYBOARD
           ===================================================== */

        this.addEventListener(
          'keydown',
          (e) => {

            if (e.key === 'ArrowLeft') {

              e.preventDefault();

              this.step(-1);

            } else if (e.key === 'ArrowRight') {

              e.preventDefault();

              this.step(1);

            }

          },
          { signal }
        );


        /* =====================================================
           SWIPE
           ===================================================== */

        viewport.addEventListener(
          'touchstart',
          (e) => {

            const t =
              e.changedTouches[0];

            this.tx = t.clientX;
            this.ty = t.clientY;

            this.hold('touch');

          },
          {
            signal,
            passive: true
          }
        );


        viewport.addEventListener(
          'touchend',
          (e) => {

            const t =
              e.changedTouches[0];

            const dx =
              t.clientX - this.tx;

            const dy =
              t.clientY - this.ty;


            this.release('touch');


            if (
              Math.abs(dx) > 40 &&
              Math.abs(dx) >
                Math.abs(dy) * 1.5
            ) {

              this.step(
                dx < 0 ? 1 : -1
              );

            }

          },
          {
            signal,
            passive: true
          }
        );


        viewport.addEventListener(
          'touchcancel',
          () => {
            this.release('touch');
          },
          {
            signal,
            passive: true
          }
        );


        /* =====================================================
           HOVER
           ===================================================== */

        this.addEventListener(
          'pointerenter',
          (e) => {

            if (e.pointerType === 'mouse') {
              this.hold('hover');
            }

          },
          { signal }
        );


        this.addEventListener(
          'pointerleave',
          (e) => {

            if (e.pointerType === 'mouse') {
              this.release('hover');
            }

          },
          { signal }
        );


        /* =====================================================
           FOCUS
           ===================================================== */

        this.addEventListener(
          'focusin',
          () => {
            this.hold('focus');
          },
          { signal }
        );


        this.addEventListener(
          'focusout',
          (e) => {

            if (!this.contains(e.relatedTarget)) {
              this.release('focus');
            }

          },
          { signal }
        );


        /* =====================================================
           VISIBILITY
           ===================================================== */

        document.addEventListener(
          'visibilitychange',
          () => {

            if (document.hidden) {

              this.hold('hidden');

            } else {

              this.release('hidden');

            }

          },
          { signal }
        );


        /* =====================================================
           INTERSECTION OBSERVER
           ===================================================== */

        if ('IntersectionObserver' in window) {

          this.io =
            new IntersectionObserver(
              ([entry]) => {

                if (entry.isIntersecting) {

                  this.release('offscreen');

                } else {

                  this.hold('offscreen');

                }

              },
              {
                threshold: 0.2
              }
            );


          this.io.observe(this);

        }


        /* =====================================================
           SHOPIFY THEME EDITOR
           ===================================================== */

        this.addEventListener(
          'shopify:block:select',
          (e) => {

            const selectedSlide =
              e.target.closest('[data-slide]');


            if (!selectedSlide) {
              return;
            }


            const i =
              this.slides.indexOf(
                selectedSlide
              );


            this.hold('editor');


            if (i > -1 && i !== this.index) {

              this.go(
                i,
                i > this.index ? 1 : -1,
                true
              );

            }

          },
          { signal }
        );


        this.addEventListener(
          'shopify:block:deselect',
          () => {
            this.release('editor');
          },
          { signal }
        );


        this.start();

      }


      /* =======================================================
         APPLY ACTIVE SLIDE RATIO
         ======================================================= */

      applyRatio(slide) {

        const d =
          parseFloat(
            slide.dataset.ratioD
          );


        const t =
          parseFloat(
            slide.dataset.ratioT
          );


        const m =
          parseFloat(
            slide.dataset.ratioM
          );


        if (d > 0) {

          this.style.setProperty(
            '--hs-ratio-d',
            d
          );

        }


        if (t > 0) {

          this.style.setProperty(
            '--hs-ratio-t',
            t
          );

        }


        if (m > 0) {

          this.style.setProperty(
            '--hs-ratio-m',
            m
          );

        }

      }


      /* =======================================================
         TEARDOWN
         ======================================================= */

      teardown() {

        this.stop();


        if (this.ac) {
          this.ac.abort();
        }


        if (this.io) {
          this.io.disconnect();
        }


        this.slides?.forEach((slide) => {

          clearTimeout(slide._t);

        });


        this.ready = false;

      }


      /* =======================================================
         AUTOPLAY HOLD
         ======================================================= */

      hold(key) {

        this.holds.add(key);

        this.stop();

      }


      release(key) {

        if (!this.holds.delete(key)) {
          return;
        }


        if (!this.holds.size) {
          this.start();
        }

      }


      /* =======================================================
         START AUTOPLAY
         ======================================================= */

      start() {

        this.stop();


        if (
          !this.autoplay ||
          this.holds.size ||
          document.hidden
        ) {
          return;
        }


        this.timer =
          setTimeout(
            () => {

              this.timer = null;

              this.step(1);

            },
            this.delay
          );

      }


      /* =======================================================
         STOP AUTOPLAY
         ======================================================= */

      stop() {

        if (this.timer) {

          clearTimeout(this.timer);

          this.timer = null;

        }

      }


      /* =======================================================
         NEXT / PREVIOUS
         ======================================================= */

      step(dir) {

        if (this.locked) {
          return;
        }


        const n =
          this.slides.length;


        this.go(
          (this.index + dir + n) % n,
          dir
        );

      }


      /* =======================================================
         GO TO SLIDE
         ======================================================= */

      go(next, dir = 1, force = false) {

        if (
          next === this.index ||
          !this.slides[next]
        ) {
          return;
        }


        if (
          this.locked &&
          !force
        ) {
          return;
        }


        this.locked = true;


        const prev =
          this.slides[this.index];


        const incoming =
          this.slides[next];


        clearTimeout(
          incoming._t
        );


        incoming.classList.remove(
          'is-leaving'
        );


        /* ===================================================
           SLIDE EFFECT
           =================================================== */

        if (this.effect === 'slide') {

          incoming.style.transition = 'none';


          incoming.style.setProperty(
            '--o',
            dir
          );


          incoming.classList.add(
            'is-active'
          );


          void incoming.offsetWidth;


          incoming.style.transition = '';


          requestAnimationFrame(() => {

            incoming.style.setProperty(
              '--o',
              0
            );


            prev.style.setProperty(
              '--o',
              -dir
            );

          });

        } else {

          incoming.classList.add(
            'is-active'
          );

        }


        /* ===================================================
           ACCESSIBILITY
           =================================================== */

        incoming.inert = false;


        prev.classList.remove(
          'is-active'
        );


        prev.classList.add(
          'is-leaving'
        );


        prev.inert = true;


        clearTimeout(
          prev._t
        );


        prev._t =
          setTimeout(
            () => {

              prev.classList.remove(
                'is-leaving'
              );

              prev.style.setProperty(
                '--o',
                dir
              );

            },
            this.duration + 50
          );


        /* ===================================================
           DOTS
           =================================================== */

        this.dots.forEach(
          (dot, i) => {

            if (i === next) {

              dot.setAttribute(
                'aria-current',
                'true'
              );

            } else {

              dot.removeAttribute(
                'aria-current'
              );

            }

          }
        );


        /* ===================================================
           INDEX + RATIO
           =================================================== */

        this.index = next;


        this.applyRatio(
          incoming
        );


        /* ===================================================
           LOCK
           =================================================== */

        setTimeout(
          () => {

            this.locked = false;

          },
          this.duration
        );


        this.start();

      }

    }


    customElements.define(
      'hero-slideshow',
      HeroSlideshow
    );

  }


  } catch(e) { console.error(e); }
})();
})();
